import Swal from "sweetalert2";
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

const getEmployeesWithNoDept = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/employees/hasNoDept/" + idUser);
};
const getCrewsWithNoDept = async (idUser) => {
  return await api.get(UtilsUrl.rhURL() + "/crews/crewhasNoDept/" + idUser);
};
const checkNomDept = async (nomDept, idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + `/depts/checkNomDept/${nomDept}/${idUser}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const insertDept = (formData) => {
  return api.post(UtilsUrl.rhURL() + "/depts/add_dept", formData);
};

const getAllDepts = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/depts/" + idUser);
  // return response.data;
};
const getDeptInfoCrewById = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/depts/crewByDept/" + idUser);
  // return response.data;
};
const deleteDept = async (idDept, setDept) => {
  try {
    const result = await Swal.fire({
      title: "Es-tu sûr?",
      text: "Vous ne pourrez pas annuler cette action !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      await api.put(UtilsUrl.rhURL() + `/depts/archiverDept/${idDept}`, {
        isDeleted: true,
      });

      Swal.fire("Supprimé !", "Equipe archiver avec succès.", "success");

      setDept((prevState) =>
        prevState.filter((dept) => dept.idDept !== idDept)
      );
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your file is safe :)", "error");
    }
  } catch (error) {
    console.error(error);
  }
};

const DeleteCrewDept = async (idEquipe, setDeptDetails, deptDetails) => {
  try {
    const result = await Swal.fire({
      title: "Es-tu sûr?",
      text: "Vous ne pourrez pas annuler cette action !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      await api.put(UtilsUrl.rhURL() + `/depts/SupprimerCrewDept/${idEquipe}`, {
        dept: null,
      });

      Swal.fire("Supprimé !", "Equipe archiver avec succès.", "success");

      const updatedEmployees = deptDetails.crews.filter(
        (crew) => crew.idEquipe !== idEquipe
      );
      setDeptDetails((prevState) => ({
        ...prevState,
        crews: updatedEmployees,
      }));
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your file is safe :)", "error");
    }
  } catch (error) {
    console.error(error);
  }
};
const updateDept = async (id, dept) => {
  return await api.put(UtilsUrl.rhURL() + `/depts/updateDept/${id}`, dept);
};
const getDeptInfoById = async (idDept) => {
  return await api.get(UtilsUrl.rhURL() + `/depts/crewByDept/${idDept}`);
};

const affecterEquipeToDept = async (idDept, formData) => {
  try {
    const response = await api.post(
      UtilsUrl.rhURL() + `/depts/affectEquipeToDept/${idDept}`,
      formData
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const updateCrewDept = async (id, dept) => {
  return await api.put(
    UtilsUrl.rhURL() + `/depts/modifierDeptEquipe/${id}`,
    dept
  );
};
export {
  getEmployeesWithNoDept,
  getCrewsWithNoDept,
  checkNomDept,
  insertDept,
  getAllDepts,
  deleteDept,
  updateDept,
  getDeptInfoById,
  affecterEquipeToDept,
  DeleteCrewDept,
  updateCrewDept,
  getDeptInfoCrewById,
};
